import { Component, Input } from "@angular/core";
import { BankingAccount } from "src/app/meta/BankingAccount.interface";
import { BillingAddress } from "src/app/meta/BillingAddress.interface";

@Component({
    selector: "ow-order-summary-banking-account",
    templateUrl: "./order-summary-banking-account.component.html"
})
export class OrderSummaryBankingAccountComponent {

    @Input() bankingAccount!: BankingAccount
    @Input() billingAddress!: BillingAddress

}
